export default {
  "content": "<g clip-path=\"url(#icon_nav_transfer_svg__a)\"><path fill-rule=\"evenodd\" d=\"M16.15.163a.54.54 0 00-.58-.13L.65 5.546a.53.53 0 00-.35.5c0 .18.09.41.35.52l6.32 2.431v.03l2 6.593c.08.27.3.38.48.38h.03c.18 0 .39-.08.5-.32L16.26.754c.08-.2.04-.42-.11-.59zm-1.32 1.371L9.57 14.059l-.07-.2-1.53-5.112 1.33-1.27c.2-.19.21-.51.02-.72a.5.5 0 00-.36-.16h-.01c-.13 0-.25.05-.35.14l-1.32 1.27h-.05L2.21 6.056 14.9 1.374l-.07.16z\" clip-rule=\"evenodd\"/></g><defs><clipPath id=\"icon_nav_transfer_svg__a\"><path d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};